import React, { useState } from 'react'

import {
  FormHeader,
  FormTitle,
  ClinicLogoContainer,
  ClinicLogo,
  InputsContainer,
  ButtonsContainer,
  FormContainer
} from '../../ui/form'

import Input from '../../ui/input'
import { Button } from '../../ui/button'
import Autocomplete from '../../ui/autoComplete'
import ClinicaSantaIsabel from '../../../assets/images/clinics/ClinicaSantaIsabel.svg'
import ClinicaBazterrica from '../../../assets/images/clinics/ClinicaBazterrica.svg'
import ClinicaDelSol from '../../../assets/images/clinics/ClinicaDelSol.svg'
import CentroMedicoBazterica from '../../../assets/images/clinics/CentroMedicoBazterica.svg'
import CentroMedicoSantaRita from '../../../assets/images/clinics/CentroMedicoSantaRita.svg'
import CentroMedicoSantaIsabel from '../../../assets/images/clinics/CentroMedicoSantaIsabel.svg'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import EntryLayout from '../../ui/layout/entryLayout'
import Select from '../../ui/select'

const initialValues = {
  docType: '',
  docNum: '',
  healthInsurance: '',
  healthPlan: '',
  credential: '',
  phoneNumber: '',
  email: ''
}

const validationSchema = Yup.object().shape({
  docType: Yup.string().required('Campo requerido'),
  docNum: Yup.string().required('Campo requerido'),
  healthInsurance: Yup.string().required('Campo requerido'),
  healthPlan: Yup.string().required('Campo requerido'),
  credential: Yup.string().required('Campo requerido'),
  email: Yup.string()
    .email('Formato de email inválido')
    .required('Campo requerido'),
  phoneNumber: Yup.string().notRequired()
})

const LoginForm = ({
  docTypes = [],
  plans = [],
  healthInsurances = [],
  handleSubmit,
  onHealthInsuranceChange
}) => {
  const documentTypes = docTypes.map(doc => ({
    value: doc.id,
    label: doc.name
  }))
  const healthInsuranceOptions = healthInsurances.map(opt => ({
    value: opt.id,
    label: opt.name
  }))

  const plansOptions = plans.map(plan => ({
    value: plan.id,
    label: plan.name
  }))

  return (
    <EntryLayout>
      <FormContainer paddingMobile="0px 15px" margin={"auto auto 0 auto"}>
        <FormHeader align="center" gap={16} mb={32}>
          <FormTitle>Turnos para Consultas Médicas</FormTitle>
          <ClinicLogoContainer gap={8}>
            <ClinicLogo src={ClinicaSantaIsabel} alt="Clínica Santa Isabel" />
            <ClinicLogo src={ClinicaDelSol} alt="Clínica del Sol" />
            <ClinicLogo src={ClinicaBazterrica} alt="Clínica Bazterrica" />
            <ClinicLogo src={CentroMedicoBazterica} alt="Centro Médico Bazterrica" />
            <ClinicLogo src={CentroMedicoSantaRita} alt="Centro Médico Santa Rita" />
            <ClinicLogo src={CentroMedicoSantaIsabel} alt="Centro Médico Santa Isabel" />
          </ClinicLogoContainer>
        </FormHeader>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <InputsContainer gap={16} mb={32}>
              <Select
                label="Tipo de documento"
                name="docType"
                value={values.docType}
                onChange={handleChange}
                onBlur={handleBlur}
                options={documentTypes}
                placeholder="Seleccioná el tipo de documento"
                error={touched.docType && errors.docType}
                fullWidth
              />
              <Input
                label="Documento"
                name="docNum"
                placeholder="Ingresá tu número de documento"
                value={values.docNum}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.docNum && errors.docNum}
                fullWidth
              />
              <Autocomplete
                label="Obra social o Prepaga"
                name="healthInsurance"
                value={values.healthInsurance}
                onChange={handleChange}
                options={healthInsuranceOptions}
                placeholder="Escribí tu obra social o prepaga"
                error={touched.healthInsurance && errors.healthInsurance}
                assignFieldValue={value => {
                  setFieldValue('healthInsurance', value)
                  setFieldValue('healthPlan', '')
                  onHealthInsuranceChange(value)
                }}
              />

              {plansOptions.length > 0 && (
                <Select
                  label="Plan"
                  name="healthPlan"
                  value={values.healthPlan}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  options={plansOptions}
                  placeholder="Seleccioná tu plan"
                  error={touched.healthPlan && errors.healthPlan}
                />
              )}

              <Input
                label="Número de credencial"
                name="credential"
                placeholder="Ingresá tu número de credencial"
                value={values.credential}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.credential && errors.credential}
              />
              <Input
                label="Email"
                name="email"
                placeholder="Ingresá tu email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.email && errors.email}
              />
              <Input
                label="Número de teléfono (opcional)"
                name="phoneNumber"
                placeholder="Ingresá tu número de teléfono"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.phoneNumber && errors.phoneNumber}
              />
              <ButtonsContainer gap={24}>
                <Button
                  label="Ingresar"
                  $variant="primary"
                  size="mobile"
                  onClick={handleSubmit}
                  disabled={
                    !values.email ||
                    !values.docNum ||
                    !values.healthInsurance ||
                    !values.credential ||
                    !values.docType ||
                    !values.healthPlan
                  }
                />
              </ButtonsContainer>
            </InputsContainer>
          )}
        </Formik>
      </FormContainer>
    </EntryLayout>
  )
}

export default LoginForm;
